/**
 Heavily inspired by material-ui Portal
 */

import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import canUseDom from "dom-helpers/util/inDOM";

class Portal extends React.Component {
  static defaultProps = {
    open: false
  };

  static propTypes = {
    children: PropTypes.node,
    open: PropTypes.bool
  };

  componentDidMount() {
    if (!ReactDOM.createPortal) {
      this.renderLayer();
    }
  }

  componentDidUpdate() {
    if (!ReactDOM.createPortal) {
      this.renderLayer();
    }
  }

  componentWillUnmount() {
    this.unrenderLayer();
  }

  getLayer() {
    if (!this.layer) {
      this.layer = document.createElement("div");
      this.layer.setAttribute("data-modal-portal", "true");

      if (document.body && this.layer) {
        document.body.style.overflow = "hidden";

        document.body.appendChild(this.layer);
      }
    }

    return this.layer;
  }

  layer: HTMLElement = null;

  unrenderLayer() {
    if (!this.layer) {
      return;
    }

    if (!ReactDOM.createPortal) {
      ReactDOM.unmountComponentAtNode(this.layer);
    }

    if (document.body) {
      document.body.removeChild(this.layer);

      if (
        document.querySelectorAll('[data-modal-portal="true"]').length === 0
      ) {
        document.body.style.overflow = "visible";
      }
    }
    this.layer = null;
  }

  renderLayer() {
    const { children, open } = this.props;

    if (open) {
      const layerElement = React.Children.only(children);

      ReactDOM.unstable_renderSubtreeIntoContainer(
        this,
        layerElement,
        this.getLayer()
      );
    } else {
      this.unrenderLayer();
    }
  }

  render() {
    const { children, open } = this.props;

    if (!ReactDOM.createPortal) {
      return null;
    }

    if (canUseDom) {
      if (open) {
        const layer = this.getLayer();

        return ReactDOM.createPortal(children, layer);
      }

      this.unrenderLayer();
    }

    return null;
  }
}

export default Portal;



// WEBPACK FOOTER //
// ./src/module/internal/Portal.js